import { E_LOGO_TYPES } from '@r-client/republic/feature/brand';

import { HEADER_THEMES } from '../types';

export const getLogo = (theme: HEADER_THEMES): E_LOGO_TYPES => {
  switch (theme) {
    case 'dark':
      return E_LOGO_TYPES.White;
    case 'new-homepage': // TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
      return E_LOGO_TYPES.RLogoBlueWhite;
    case 'light':
    case 'r-note-teaser':
    default:
      return E_LOGO_TYPES.Black;
  }
};
